var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"print-table"},[_vm._m(0),_c('tbody',_vm._l((_vm.selfData),function(item,index){return _c('tr',{key:index},[_c('td',{attrs:{"align":"center"}},[_vm._v(_vm._s(index + 1))]),_c('td',[_vm._v(_vm._s(item.qi_ta_yao_qiu))])])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[_c('th',{attrs:{"width":"24"}},[_vm._v("序号")]),_c('th',{attrs:{"align":"left"}},[_vm._v("其他要求")])])])
}]

export { render, staticRenderFns }